<div class="selectedAmin" *ngIf="selectedAmin" [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpened()">
    <img [src]="s3Bucket+selectedAmin.Logo" (error)="commonMetod._getUrlErrorImg('employer', $event)">
    <mat-icon>keyboard_arrow_down</mat-icon>
</div>
<mat-menu #menu="matMenu" class="menuSelectAdmin">
    <!-- Buscador de administradoras: el clic y las teclas no deben cerrar ni mover el menu. -->
    <div class="searchAdmin" (click)="$event.stopPropagation()" (keydown)="onSearchKeydown($event)">
        <mat-icon>search</mat-icon>
        <input #searchAdminInput type="text" placeholder="Buscar administradora..." autocomplete="off"
               [(ngModel)]="searchText" (keydown.enter)="selectFirstFiltered()">
    </div>
    <button mat-menu-item *ngFor="let company of filteredCompanies" style="display: flex; align-items: center;" (click)="selected(company)">
        <img width="40" height="40" [src]="s3Bucket+company.Logo" (error)="commonMetod._getUrlErrorImg('employer', $event)">
        <span>{{company.Name || ''}}</span>
    </button>
    <div class="searchAdminEmpty" *ngIf="filteredCompanies.length === 0">No se encontraron administradoras</div>
</mat-menu>
